import { Vue, Prop, Component } from "vue-property-decorator";
import DayOfWeekPreferences from './dow-preferences.model';

@Component
export default class SchedulingPreferences extends Vue {
    @Prop() id!: string;
    @Prop() username!: string;
    @Prop() tenantId!: string;
    @Prop() employeeName!: string;
    @Prop() staffId!: number;
    @Prop() selfScheduling!: boolean;
    @Prop() marketFloat!: boolean;
    @Prop() daysOfWeek!: DayOfWeekPreferences[];
    @Prop() shiftPattern!: number;
}


